import { Linkedin, Youtube, Cloud, BookOpen, Sparkles, Github, BadgeCheck } from "lucide-react";

const LINKS = [
  {
    label: "Bluesky",
    href: "https://bsky.app/profile/magee.bsky.social",
    icon: Cloud,
    testid: "footer-link-bluesky",
  },
  {
    label: "Medium",
    href: "https://anthony-magee.medium.com/",
    icon: BookOpen,
    testid: "footer-link-medium",
  },
  {
    label: "LinkedIn",
    href: "https://uk.linkedin.com/in/anthonymagee",
    icon: Linkedin,
    testid: "footer-link-linkedin",
  },
  {
    label: "GitHub",
    href: "https://github.com/anthonyjmagee/anthonymagee.com",
    icon: Github,
    testid: "footer-link-github",
  },
  {
    label: "Certifications",
    href: "https://www.credential.net/profile/anthonymagee339143/wallet",
    icon: BadgeCheck,
    testid: "footer-link-certifications",
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/watch?v=w7Kxy31hDD8",
    icon: Youtube,
    testid: "footer-link-youtube",
  },
  {
    label: "Charity AI Maturity Tool",
    href: "https://www.anthonymagee.com/charity-maturity-tool",
    icon: Sparkles,
    testid: "footer-link-charity-ai-maturity-tool",
  },
];

export default function Footer() {
  return (
    <footer className="mt-12 pb-12">
      <div className="h-px w-full bg-[rgba(244,236,224,0.14)]" />
      <nav
        className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-sm"
        aria-label="Anthony's links"
      >
        {LINKS.map(({ label, href, icon: Icon, testid }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noreferrer"
            data-testid={testid}
            aria-label={`${label} (opens in new tab)`}
            className="inline-flex items-center gap-2 text-[rgba(244,236,224,0.82)] hover:text-[#F4ECE0] underline underline-offset-4 decoration-[rgba(244,236,224,0.25)] hover:decoration-[rgba(244,236,224,0.6)] transition-colors duration-200"
          >
            <Icon className="h-4 w-4" />
            <span>{label}</span>
          </a>
        ))}
      </nav>
      <p className="mt-6 text-center text-xs text-[rgba(244,236,224,0.6)]">
        © {new Date().getFullYear()} Anthony Magee. Built with curiosity,
        crimson, and a refusal to be corporate.
      </p>
    </footer>
  );
}
